/** PPR-6 · 上架中心「同行站」页签：促销页横幅 / 入口的后台接口（后端 routes/partner_promo_admin.py）+ 展示清单（PPR-1 partner_site_admin.py，选跳转产品用）。 */
import { api } from "./api";

export interface PromoBanner {
  id?: string;
  image_media_id: string;
  /** 图片库素材的地址（只读，后端按 media id 带回；新选的图前端取素材详情带上） */
  image_url?: string | null;
  /** 图片库里的图没了 / 停用了：前台这张不出，后台标红让人去补 */
  image_missing?: boolean;
  title: string;
  subtitle?: string | null;
  link_product_id: string | null;
  link_product_code?: string | null;
  link_product_name?: string | null;
  /** 跳转的产品同行站有没有在展示（没在展示 → 前台这张图不带跳转）；没设跳转 = null */
  link_visible?: boolean | null;
  active: boolean;
  sort?: number;
}
export interface PromoBanners { max: number; items: PromoBanner[] }

export type PromoRuleType = "departure_city" | "tag";
export const RULE_TYPE_LABEL: Record<PromoRuleType, string> = { departure_city: "按出发城市", tag: "按标签" };
export interface PromoEntry {
  id?: string;
  name: string;
  rule_type: PromoRuleType;
  rule_value: string;
  active: boolean;
  /** 当前有几个产品（同行站开关打开的）；0 = 前台显示「即将上线」。只读，保存时不用带 */
  product_count?: number;
  coming_soon?: boolean;
}
export interface PromoEntries { max: number; items: PromoEntry[] }

/** 上架中心「同行站」展示清单里选跳转产品用（PPR-1：GET /api/v1/partner-site/products） */
export interface PartnerSiteProduct {
  product_id: string;
  code: string;
  name_cn: string;
  display_status: "showing" | "hidden" | "not_showing";
  reason_label: string | null;
}

export const PROMO_QK = {
  banners: ["partner-site", "promo-banners"] as const,
  entries: ["partner-site", "promo-entries"] as const,
  products: ["partner-site", "products"] as const,
};

const BASE = "/api/v1/partner-site";

export const getPromoBanners = () => api<PromoBanners>(`${BASE}/promo-banners`);
export const putPromoBanners = (items: { image_media_id: string; title: string; subtitle?: string | null; link_product_id: string | null; active: boolean }[]) =>
  api<PromoBanners>(`${BASE}/promo-banners`, { method: "PUT", body: JSON.stringify({ items }) });

export const getPromoEntries = () => api<PromoEntries>(`${BASE}/promo-entries`);
export const putPromoEntries = (items: { name: string; rule_type: PromoRuleType; rule_value: string; active: boolean }[]) =>
  api<PromoEntries>(`${BASE}/promo-entries`, { method: "PUT", body: JSON.stringify({ items }) });

export const listPartnerSiteProducts = () => api<{ items: PartnerSiteProduct[] }>(`${BASE}/products`);
